import shared from 'servicestack/_labels.es6';

export default Object.assign(shared, {
    DontMaskPhone: false,
	StoreCategory: "Ship to Type",
    OpenTotal: false
});
